import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import Table from "../../../core/common/dataTable/index";
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../core/data/redux/store'
import { fetchAssetById } from '../../../core/data/redux/asset/asset/assetActions'
import { formatDate } from '../../../core/utils/FormatData';


const AssetDetails = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedAsset } = useSelector((state: any) => state.asset.newAsset);
    const [tableKey, setTableKey] = useState(0);
    const { assetId } = useParams<{ assetId: string }>();

    useEffect(() => {
        if (assetId) {
            dispatch(fetchAssetById(Number(assetId)));
        }
    }, [dispatch, assetId])

      useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
      }, [dispatch, selectedAsset]);

    const data = selectedAsset?.asset_details ? selectedAsset?.asset_details : [];
    const columns = [
        {
            title: "Asset Tag Number",
            dataIndex: "AssetTagNumber",
            sorter: (a: any, b: any) =>
                a.AssetTagNumber.length - b.AssetTagNumber.length,
        },
        {
            title: "Serial Number",
            dataIndex: "SerialNumber",
            sorter: (a: any, b: any) =>
                a.SerialNumber.length - b.SerialNumber.length,
        },
        {
            title: "Warranty Date",
            dataIndex: "WarrantyDate",
            render: (text: string) => formatDate(text),
            sorter: (a: any, b: any) =>
                a.WarrantyDate.length - b.WarrantyDate.length,
        },
        {
            title: "Assign To",
            dataIndex: "employee_name",
            render: (_: any, record: any) => {
                if (record.employee_name) {
                    return <span style={{ color: 'orange' }}>{record.employee_name}</span>;
                } else {
                    return <span style={{ color: 'red' }}>None</span>;
                }
            },
            sorter: (a: any, b: any) =>
                a.employee_name.length - b.employee_name.length,
        },
        {
            title: "Asset Status",
            dataIndex: "asset_status",
            render: (_: any, record: any) => {
                return <span style={{ color: 'green' }}>{record.status}</span>;
            },
            sorter: (a: any, b: any) =>
                a.asset_status.length - b.asset_status.length,
        },
    ];
    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                                <Link to={all_routes.assetList}>
                                    <i className="ti ti-arrow-left me-2" />
                                    Asset Details
                                </Link>
                            </h6>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="row">
                        <div className="col-xl-4 theiaStickySidebar">
                            <div className="card ">
                                <div className="card-body p-0">
                                    <img src={selectedAsset?.Images} alt="Profile" className="img-fluid " />
                                    <div className="text-center px-3 pb-3 border-bottom mt-3">
                                        <div className="mb-3">
                                            <h4>
                                                {selectedAsset?.AssetName}
                                            </h4>
                                            <span className="badge badge-soft-secondary fw-medium">
                                                {selectedAsset?.asset_category_name}
                                            </span>
                                        </div>
                                        <div>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <span className="d-inline-flex align-items-center">
                                                    <i className="ti ti-id me-2" />
                                                    Asset ID
                                                </span>
                                                <p className="text-dark">{selectedAsset?.Id}</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <span className="d-inline-flex align-items-center">
                                                    <i className="ti ti-cpu me-2" />
                                                    Model
                                                </span>
                                                <p className="text-dark">{selectedAsset?.Model}</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <span className="d-inline-flex align-items-center">
                                                    <i className="ti ti-calendar-check me-2" />
                                                    Purchase Date
                                                </span>
                                                <p className="text-dark">{formatDate(selectedAsset?.PurchaseDate)}</p>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <span className="d-inline-flex align-items-center">
                                                    <i className="ti ti-cash me-2" />
                                                    Purchase Price
                                                </span>
                                                <div className="d-flex align-items-center">

                                                    <p className="text-gray-9 mb-0">{selectedAsset?.PurchasePrice}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-3 border-bottom">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <h6>Basic information</h6>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ti ti-phone me-2" />
                                                Purchase From
                                            </span>
                                            <p className="text-dark">{selectedAsset?.PurchaseFrom}</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ti ti-calendar-plus me-2" />
                                                CreatedAt
                                            </span>
                                            <p className="text-dark">{formatDate(selectedAsset?.CreatedAt)}</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ti ti-gender-male me-2" />
                                                Quantity
                                            </span>
                                            <p className="text-dark text-end">{selectedAsset?.Quantity}</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ti ti-cake me-2" />
                                                Vendor
                                            </span>
                                            <p className="text-dark text-end">{selectedAsset?.PurchaseFrom}</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ti ti-map-pin-check me-2" />
                                                Description
                                            </span>
                                            <p className="text-dark text-end">
                                                {selectedAsset?.Description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 card" >
                            <div className="card-body p-0">
                                <Table key={tableKey} dataSource={data} columns={columns} />
                            </div>
                        </div>

                    </div>

                    <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                        <p className="mb-0">2024 - 2025© hrmtree.</p>
                        <p>
                            Developed By{" "}
                            <Link to="#" className="text-primary">
                                Leadchain Systems
                            </Link>
                        </p>
                    </div>
                </div>



            </div>
        </>
    )
}

export default AssetDetails